import { render, staticRenderFns } from "./comment-input.vue?vue&type=template&id=6f88ec34&scoped=true&"
import script from "./comment-input.vue?vue&type=script&lang=ts&"
export * from "./comment-input.vue?vue&type=script&lang=ts&"
import style0 from "./comment-input.vue?vue&type=style&index=0&id=6f88ec34&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f88ec34",
  null
  
)

export default component.exports